import PropTypes from 'prop-types'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

const logError = (error, info) => {
  // Log to 3rd party error monitoring service here
}

export const ErrorBoundary = (props) => {
  return (
    <ReactErrorBoundary
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      onError={(...args) => {
        logError(...args)
        props.onError(...args)
      }}
    />
  )
}

ErrorBoundary.propTypes = {
  onError: PropTypes.func,
}

ErrorBoundary.defaultProps = {
  onError: () => {},
}

const GenericErrorFallback = () => {
  return (
    <div className="pal text-center">
      Something went wrong. Try{' '}
      <a href={window.location.href}>reloading the page.</a>
    </div>
  )
}

export const GenericErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary FallbackComponent={GenericErrorFallback}>
      {children}
    </ErrorBoundary>
  )
}

GenericErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}
